<template>
  <div class="rs-section section-uq">
    <a-affix :offsetTop="0" :target="affixTarget">
      <div class="list-toolbar-wrapper">
        <div class="list-toolbar flex items-center">
          <a-space class="v-mr-auto">
            <!-- <a-button icon="check" type="primary" size="small" @click="onPassedAll">审核通过</a-button>
            <a-button icon="stop" type="primary" size="small" @click="onRejectAll">审核不通过</a-button> -->
            <a-button icon="plus" type="primary" size="small" @click="handleOpenQForm">添加发言</a-button>
            <a-button icon="reload" type="link" class="bg-deep-orange text-white" size="small" @click="load()">刷新</a-button>
            <!-- <a-radio-group size="small" v-model="listType" button-style="solid" @change="handleListTypeChange">
              <a-radio-button :value="1"><a-icon type="menu" /></a-radio-button>
              <a-radio-button :value="2"><i class="fa fa-comments-o" /></a-radio-button>
            </a-radio-group> -->
            <a-input-group compact size="small">
              <a-select size="small" v-model="searchRange">
                <a-select-option value="speakerName">按作者</a-select-option>
                <a-select-option value="content">按内容</a-select-option>
                <a-select-option value="number">按序号</a-select-option>
                <a-select-option value="qType">按分类</a-select-option>
              </a-select>
              <a-input-search size="small" style="width: 140px" v-model="searchKey" @search="handleSearch" allow-clear />
            </a-input-group>
          </a-space>
          <div class="list-toolbar-extra">
            共
            <span class="text-primary font-special">{{ pagination.total }}</span>
            条记录
          </div>
          <div class="list-pagination">
            <a-pagination
              size="small"
              :total="pagination.total"
              :current.sync="pagination.pageNum"
              :page-size="pagination.pageSize"
              show-less-items
              show-size-changer
              show-quick-jumper
              @change="onPageChange"
              @showSizeChange="onPageChange"
            />
          </div>
          <!-- <a-space class="v-ml-auto">
            <a-button icon="check" type="primary" size="small" @click="onPassedAll">审核通过</a-button>
            <a-button icon="stop" type="primary" size="small" @click="onRejectAll">审核不通过</a-button>
            <a-button icon="export" type="link" class="bg-deep-orange text-white" size="small">导出</a-button>
            <a-button icon="reload" type="link" class="bg-deep-orange text-white" size="small">刷新</a-button>
          </a-space> -->
        </div>
      </div>
    </a-affix>
    <a-spin :spinning="loading" tip="加载中...">
      <table class="rs-table table-dense">
        <thead>
          <tr>
            <!-- <th width="50" class="text-center"><a-checkbox :checked="checkedAll" @change="onCheckAllChange" /></th> -->
            <th width="60" class="text-center">序号</th>
            <th width="100" class="text-center">作者</th>
            <th class="text-center">发言内容</th>
            <th width="140" class="text-center">时间</th>
            <th width="74" class="text-center">状态</th>
            <th width="100" class="text-center">操作</th>
          </tr>
        </thead>
        <tbody v-if="list.length > 0">
          <tr class="msg-row-question" v-for="item in list" :key="item.spId" :class="{ 'msg-row-checked': item.checked }">
            <!-- <td class="text-center"><a-checkbox :checked="item.checked" @change="onCheckChange(item)" /></td> -->
            <td class="text-center">{{ item.spNumber }}</td>
            <td class="text-center">{{ item.spSpeakerName }}</td>
            <td>
              <div v-html="$utils.convertToHtml(item.spContent)"></div>
            </td>
            <td class="text-center">{{ item.spDatetime }}</td>
            <td class="text-center">
              <span class="text-red" v-if="item.spState === 0">待审核</span>
              <span v-else-if="item.spState === 1">已通过</span>
              <span class="text-grey" v-else-if="item.spState === 2">已封禁</span>
            </td>
            <td class="text-center">
              <a-space class="table-actions" :size="4">
                <span class="table-action" title="审核通过" @click="onPassed(item)" v-if="item.spState !== 1"><a-icon type="check" /></span>
                <span class="table-action text-red" title="审核不通过" @click="onReject(item)" v-if="item.spState !== 2"><a-icon type="stop" /></span>
                <span class="table-action" title="编辑" @click="onEditRecord(item)"><a-icon type="edit" /></span>
              </a-space>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="padding: 30px 0" v-if="!loading && list.length === 0"><a-empty /></div>
    </a-spin>
    <!-- <a-modal destroy-on-close :visible="qModel" :width="800" title="编辑提问" @cancel="handleCloseQForm">
      <a-form-model ref="ruleForm" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item prop="spSpeakerName">
          <span slot="label"><b class="text-red">*</b> 发言人</span>
          <a-select style="width: 500px" placeholder="选择发言人" allowClear v-model="form.spSpeakerId" ref="spSpeakerId">
            <a-select-option value="主持人">主持人</a-select-option>
            <a-select-option v-for="item in guests" :key="item.gId" :value="item.gId">
              {{ item.gName }}<template v-if="item.gPost">（{{ item.gPost }}）</template>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="spDatetime">
          <span slot="label"><b class="text-red">*</b> 发言时间</span>
          <a-date-picker v-model="form.spDatetime" show-time placeholder="选择时间" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" ref="spDatetime" />
        </a-form-model-item>
        <a-form-model-item prop="spContent">
          <span slot="label"><b class="text-red">*</b> 发言内容</span>
          <a-textarea v-model="form.spContent" placeholder="发言内容" :rows="6" ref="spContent" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="handleCloseQForm">取 消</a-button>
        <a-button type="primary" :loading="qSaving" @click="handleSubmit">保 存</a-button>
      </template>
    </a-modal> -->
    <a-modal destroy-on-close :visible="qModel" :width="800" :title="qModalTitle" @cancel="handleCloseQForm">
      <question-form :data="selectedRecord" ref="form" />
      <template slot="footer">
        <a-button @click="handleCloseQForm">取 消</a-button>
        <a-button type="primary" :loading="qSaving" @click="handleSaveQForm(1)">保 存</a-button>
        <!-- <a-button type="primary" :loading="qSaving" @click="handleSaveQForm(1)" v-if="selectedRecord.spState !== 1">保存并审核通过</a-button> -->
      </template>
    </a-modal>
  </div>
</template>

<script>
import audit from '@/mixins/audit'
import { getSpeakListByPage, auditSpeak, saveSpeak } from '@/api/interact'
import moment from 'moment'
import QuestionForm from './question-form.vue'
const form = {
  spSpeakerId: undefined,
  spSpeakerName: '',
  spGuest: '',
  spCate: '',
  spDatetime: '',
  spContent: '',
  spType: 1,
}
export default {
  components: {
    QuestionForm,
  },
  mixins: [audit],
  data() {
    return {
      rsId: this.$route.query.id,
      listType: 1,
      searchRange: 'speakerName',
      searchKey: '',
      loading: false,
      list: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      form: {},
      selectedRecord: {},
      qModel: false,
      qSaving: false,
      qModalTitle: '',
    }
  },
  computed: {
    checkedAll() {
      return this.list.length > 0 && this.list.filter((item) => item.checked).length === this.list.length
    },
  },
  methods: {
    load(pageNum = 1, pageSize = 10) {
      let { type } = this.userinfo
      this.loading = true
      // 待审核的未回复问题
      let params = {
        pageNum,
        pageSize,
        rsId: this.rsId,
        type: type === 2 ? '1,2' : '1',
        // state: 1,
      }
      params[this.searchRange] = this.searchKey.trim()
      getSpeakListByPage(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          this.list = records.map((record) => ({ ...record, checked: false }))
          this.pagination = {
            pageNum: current,
            pageSize: size,
            total,
          }
        }
        this.loading = false
      })
    },
    handleSearch() {
      this.load()
    },
    handleListTypeChange() {
      this.load()
    },
    onPageChange(pageNum, pageSize) {
      this.load(pageNum, pageSize)
    },
    onEditRecord(record) {
      this.selectedRecord = { ...record }
      this.qModel = true
    },
    handleCloseQForm() {
      this.qModel = false
    },
    handleOpenQForm() {
      this.qModalTitle = '添加发言'
      this.selectedRecord = { ...form, spDatetime: moment().format('YYYY-MM-DD HH:mm:ss'), rsId: this.rsId }
      this.qModel = true
    },
    handleSaveQForm(passed) {
      this.qSaving = true
      this.$refs.form
        .handleSubmit(passed)
        .then(() => {
          this.qSaving = false
          this.qModel = false
          this.load()
          this.$message.success('操作成功')
        })
        .catch((e) => {
          console.log(e)
          this.qSaving = false
        })
    },
    onCheckChange(item) {
      console.log('onCheckChange', item)
      item.checked = !item.checked
    },
    onCheckAllChange(e) {
      let checked = e.target.checked
      if (checked) {
        this.list.forEach((item) => {
          item.checked = true
        })
      } else {
        this.list.forEach((item) => {
          item.checked = false
        })
      }
    },
    handleAudit(ids, state) {
      auditSpeak(ids, state).then(({ data }) => {
        if (data.success) {
          this.$message.success('操作成功')
          this.load()
        } else {
          this.$message.warning('操作失败')
        }
      })
    },
    onPassedAll() {
      let ids = this.list.reduce((a, b) => (b.checked ? a.concat(b.spId) : a), [])
      this.$message.destroy()
      if (ids.length === 0) {
        this.$message.warning('请至少选择一条记录！')
        return false
      }
      this.handleAudit(ids.join(','), 1)
    },
    onRejectAll() {
      let ids = this.list.reduce((a, b) => (b.checked ? a.concat(b.spId) : a), [])
      this.$message.destroy()
      if (ids.length === 0) {
        this.$message.warning('请至少选择一条记录！')
        return false
      }
      this.handleAudit(ids.join(','), 2)
    },
    onPassed(item) {
      this.handleAudit(item.spId, 1)
    },
    onReject(item) {
      this.handleAudit(item.spId, 2)
    },
  },
  mounted() {
    this.load()
  },
}
</script>
